import { ApiConnector, DELETE, GET, POST, PUT } from './requestV2.service';

export default (() => {
    const API = ApiConnector('/news', true);

    return {
        CreateNews: async data => await API(POST, `/create`).call(data),
        GetAllNewsAdmin: async (data, query) => await API(GET, '/get-all-news/super-boss', false, query).call(data),
        GetAllNewsBoss: async (data, query) => await API(GET, '/get-all/boss', false, query).call(data),
        GetAllNewsUser: async (data, query) => await API(GET, '/get-all/teacher-frach', false, query).call(data),
        GetNewsById: async id => await API(GET, `/single/${id}`).call(),
        getNewsForTeacherOrFranchiseeById: async id => await API(GET, `/single-teacher-franch/${id}`).call(),
        GetNewNews: async () => await API(GET, `/reveal`).call(),
        MarkNewsAsSeen: async id => await API(POST, `/acknowledge/${id}`).call(),
        MarkNewsAsRead: async id => await API(POST, `/view/${id}`).call(),
        EditNews: async (id, data) => await API(PUT, `/update/${id}`).call(data),
        DeleteNews: async id => await API(DELETE, `/delete/${id}`).call(),
        GetUnviewedNews: async () => await API(GET, `/unviewed-news`).call(),
    };
})();
